import { SmartSendSettingsApiResponseModel } from '../api/smartsend/types';

export const DashHome = './';
export interface IAppSettings extends SmartSendSettingsApiResponseModel {}

export interface IAppSettingsBase extends IAppSettings {
  DashHome: string;
}

export interface ISettingsCache {
  settings: IAppSettingsBase;
  profile: string | null;
  currencyCode: string;
  appToken: string | null;
}

export const SettingsCache: ISettingsCache = {
  profile: null,
  appToken: null,
  currencyCode: 'GBP',
  settings: {
    Limits: {
      CreateBatchSize: 150,
      QuoteBatchSize: 100,
      UpdateBatchSize: 150,
      MaxStandardQueueConcurrency: 3,
      MaxQuoteQueueConcurrency: 2,
      MaxBookQueueConcurrency: 1,
      SmartSendOrderSize: 100,
      SmartSendMaxOrders: 1000
    },
    Features: [],
    SmartSend: { Name: 'Smart Send', SmartSendProviderName: 'Parcel2Go' },
    Links: {},
    Icons: {},
    Downloads: {},
    DashHome: DashHome,
    MarketplaceCourierLimits: {}
  }
};
